import { render, staticRenderFns } from "./EditServiceDocumentPage.vue?vue&type=template&id=c87d9440&scoped=true"
import script from "./EditServiceDocumentPage.vue?vue&type=script&lang=js"
export * from "./EditServiceDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87d9440",
  null
  
)

export default component.exports